import _ from 'underscore';

const formatName = function (value) {
  let newValue = value;

  if (_.contains(value, '"')) {
    newValue = value.replace(/"/g, '""');
  }

  if (_.contains(value, ',') || _.contains(value, '"') || _.contains(value, '\n')) {
    newValue = `"${value}"`;
  }

  return newValue;
};

export const Criterion = {
  'bulk-upload-full-mapper': function (criterion) {
    let pairs = [];
    if (criterion.Type === 'Device') {
      pairs.push({
        key: 'Target',
        value: criterion.DeviceCriterion.DeviceName,
      });
      pairs.push({
        key: 'Bid Adjustment',
        value: criterion.BidAdjustment,
      });
      pairs.push({
        key: 'OS Names',
        value: criterion.DeviceCriterion.OSName,
      });
      pairs.push({
        key: 'Cashback Percent',
        value: criterion.CashbackPercent,
      });
    } else if (criterion.Type === 'Audience') {
      pairs = [];
      pairs.push({
        key: 'Bid Adjustment',
        value: criterion.BidMultiplier,
      });
      pairs.push({
        key: 'Audience Id',
        value: criterion.AudienceId,
      });
      pairs.push({
        key: 'Audience',
        value: formatName(criterion.AudienceName),
      });
      pairs.push({
        key: 'Cashback Percent',
        value: criterion.CashbackPercent,
      });
    } else if (criterion.Type === 'Age') {
      pairs.push({
        key: 'Target',
        value: criterion.AgeCriterion.Target,
      });
      pairs.push({
        key: 'Bid Adjustment',
        value: criterion.BidAdjustment,
      });
      pairs.push({
        key: 'Cashback Percent',
        value: criterion.CashbackPercent,
      });
    } else if (criterion.Type === 'Gender') {
      pairs.push({
        key: 'Target',
        value: criterion.GenderCriterion.Target,
      });
      pairs.push({
        key: 'Bid Adjustment',
        value: criterion.BidAdjustment,
      });
      pairs.push({
        key: 'Cashback Percent',
        value: criterion.CashbackPercent,
      });
    } else if (criterion.Type === 'CompanyName') {
      pairs.push({
        key: 'Profile Id',
        value: criterion.CompanyNameCriterion.Target,
      });
      pairs.push({
        key: 'Bid Adjustment',
        value: criterion.BidAdjustment,
      });
      pairs.push({
        key: 'Cashback Percent',
        value: criterion.CashbackPercent,
      });
    } else if (criterion.Type === 'Industry') {
      pairs.push({
        key: 'Profile Id',
        value: criterion.IndustryCriterion.Target,
      });
      pairs.push({
        key: 'Bid Adjustment',
        value: criterion.BidAdjustment,
      });
      pairs.push({
        key: 'Cashback Percent',
        value: criterion.CashbackPercent,
      });
    } else if (criterion.Type === 'JobFunction') {
      pairs.push({
        key: 'Profile Id',
        value: criterion.JobFunctionCriterion.Target,
      });
      pairs.push({
        key: 'Bid Adjustment',
        value: criterion.BidAdjustment,
      });
      pairs.push({
        key: 'Cashback Percent',
        value: criterion.CashbackPercent,
      });
    } else if (criterion.Type === 'Radius') {
      if (criterion.RadiusCriterion.Name) {
        pairs.push({
          key: 'Name',
          value: `"${criterion.RadiusCriterion.Name}"`,
        });
      }
      pairs.push({
        key: 'Radius',
        value: criterion.RadiusCriterion.Radius,
      });
      pairs.push({
        key: 'Bid Adjustment',
        value: criterion.BidAdjustment,
      });
      pairs.push({
        key: 'Cashback Percent',
        value: criterion.CashbackPercent,
      });
      pairs.push({
        key: 'Unit',
        value: criterion.RadiusCriterion.RadiusUnit,
      });
      pairs.push({
        key: 'Latitude',
        value: criterion.RadiusCriterion.Latitude,
      });
      pairs.push({
        key: 'Longitude',
        value: criterion.RadiusCriterion.Longitude,
      });
    } else if (criterion.Type === 'Location' || criterion.Type === 'NegativeLocation') {
      pairs.push({
        key: 'Sub Type',
        value: criterion.LocationCriterion.LocationType,
      });
      pairs.push({
        key: 'Bid Adjustment',
        value: criterion.BidAdjustment,
      });
      pairs.push({
        key: 'Cashback Percent',
        value: criterion.CashbackPercent,
      });
      pairs.push({
        key: 'Target',
        value: criterion.LocationCriterion.LocationId,
      });
    } else if (criterion.Type === 'LocationIntentCriterion') {
      pairs.push({
        key: 'Target',
        value: criterion.LocationIntentCriterion.IntentOption,
      });
    } else if (criterion.Type === 'NegativeStore') {
      pairs.push({
        key: 'Store Id',
        value: criterion.NegativeStoreCriterion.StoreId,
      });
    } else if (criterion.Type === 'DayTime') {
      pairs.push({
        key: 'Target',
        value: criterion.DayTimeCriterion.Day,
      });
      pairs.push({
        key: 'Bid Adjustment',
        value: criterion.BidAdjustment,
      });
      pairs.push({
        key: 'Cashback Percent',
        value: criterion.CashbackPercent,
      });
      pairs.push({
        key: 'From Hour',
        value: criterion.DayTimeCriterion.FromHour,
      });
      pairs.push({
        key: 'From Minute',
        value: criterion.DayTimeCriterion.FromMinute,
      });
      pairs.push({
        key: 'To Hour',
        value: criterion.DayTimeCriterion.ToHour,
      });
      pairs.push({
        key: 'To Minute',
        value: criterion.DayTimeCriterion.ToMinute,
      });
    } else if (criterion.Type === 'Webpage') {
      const conditions = criterion.WebPage.Parameter.Conditions;
      const isAllWebpage = conditions.length === 0;

      for (let i = 0; i < 3; i += 1) {
        const setEmpty = isAllWebpage || _.isUndefined(conditions[i]);

        pairs.push({
          key: `Dynamic Ad Target Condition ${i + 1}`,
          value: setEmpty ? '' : conditions[i].Operand.replace('PageTitle', 'PAGE_TITLE').replace('PageContent', 'PAGE_CONTENT'),
        });

        pairs.push({
          key: `Dynamic Ad Target Condition Operator ${i + 1}`,
          value: setEmpty ? '' : conditions[i].Operator,
        });

        pairs.push({
          key: `Dynamic Ad Target Value ${i + 1}`,
          value: setEmpty ? '' : conditions[i].ArgumentOperand,
        });
      }
    } else if (criterion.Type === 'AdvanceBookingWindow') {
      pairs.push({
        key: 'Min Target Value',
        value: criterion.AdvanceBookingWindowCriterion.MinDays,
      });
      pairs.push({
        key: 'Max Target Value',
        value: criterion.AdvanceBookingWindowCriterion.MaxDays,
      });
      pairs.push({
        key: 'Bid Adjustment',
        value: criterion.BidAdjustment,
      });
    } else if (criterion.Type === 'CheckInDay') {
      pairs.push({
        key: 'Target',
        value: criterion.CheckInDayCriterion.CheckInDay,
      });
      pairs.push({
        key: 'Bid Adjustment',
        value: criterion.BidAdjustment,
      });
    } else if (criterion.Type === 'LengthofStay') {
      pairs.push({
        key: 'Min Target Value',
        value: criterion.LengthofStayCriterion.MinNights,
      });
      pairs.push({
        key: 'Max Target Value',
        value: criterion.LengthofStayCriterion.MaxNights,
      });
      pairs.push({
        key: 'Bid Adjustment',
        value: criterion.BidAdjustment,
      });
    } else if (criterion.Type === 'CheckInDate') {
      pairs.push({
        key: 'Min Target Value',
        value: criterion.CheckInDateCriterion.StartDate,
      });
      pairs.push({
        key: 'Max Target Value',
        value: criterion.CheckInDateCriterion.EndDate,
      });
      pairs.push({
        key: 'Bid Adjustment',
        value: criterion.BidAdjustment,
      });
    } else if (criterion.Type === 'DateSelectionType') {
      pairs.push({
        key: 'Target',
        value: criterion.DateSelectionTypeCriterion.HotelDateSelectionType,
      });
      pairs.push({
        key: 'Bid Adjustment',
        value: criterion.BidAdjustment,
      });
    }
    return pairs;
  },
};
